import { Icon, Typography, color } from '@uniquegood/realworld-studio-design';
import { css } from '@emotion/react';

interface ExclamationModalContentProps {
  description: string;
}

function ExclamationModalContent({ description }: ExclamationModalContentProps) {
  return (
    <div css={styles.container}>
      <Icon
        icon="exclamation_circle_solid"
        size="100px"
        color={color.interactive_critical_default}
      />
      <Typography type="body" cssStyle={styles.description}>
        {description}
      </Typography>
    </div>
  );
}

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 16px;
  `,

  description: css`
    color: ${color.text_default};
    margin: 0;
    line-height: 1.5;
    white-space: pre-line;
  `
};

export default ExclamationModalContent;
